module.exports = __webpack_public_path__ + "static/media/WaitingForSupplierSignature.5b3a05f5.svg";